import { Address, KngButtonState, PageInfo, SortOrder } from 'kinetic-angular';
import { FilterData, FilterPanelSection, Image, LocationAddress, NoResultModel, PromoBannerApiResponse  } from '../../../services/shared/shared-interface';

export interface MyQuotes {
    state: MyQuotesState;
}
export interface MyQuotesState {
    sectionTop: MyQuotesSectionTop;
    sectionMiddle: MyQuotesSectionMiddle;
    sectionBottom: MyQuotesSectionBottom;
}
export interface MyQuotesSectionTop {
    heading: string;
}
export interface MyQuotesSectionMiddle {
    heading: string;
    search: {
        placeholder: string;
        icon: Image;
        invalidSearchText:string;
    };
    filter: FilterData;
    filteringPanelSection: FilterPanelSection;
    download: KngButtonState;
    downloadPdfPayload : DownloadPDFPayload;
    invoiceStatusUpdated: boolean;
    gridData:MyQuotesGridListLabel;
    noResult: NoResultModel;
}
export interface DownloadPDFPayload {
    documentURL : string | undefined;
}
export interface MyQuotesSectionBottom {
    sectionPromoBanner : PromoBannerApiResponse;
}

export interface MyQuotesLabelState {
    sectionTop: MyQuotesSectionTop;
    sectionMiddle: MyQuotesSectionMiddleLabel;
    sectionBottom: MyQuotesSectionBottomLabel;
}
export interface MyQuotesSectionMiddleLabel {
    heading: string;
    search: {
        placeholder: string;
        icon: Image;
        invalidSearchText: string;
    };
    filter: FilterData;
    filterForm: FilterFormData;
    download: string;
    invalidSearchText: string;
    gridData:MyQuotesGridListLabel;
    noResult: NoResultModel;
}
export interface FilterFormData {
    formLabel: string;
    dateRange: {
        accordionIconExpanded: Image;
        accordionIconCollapsed: Image;
        label: string;
        values: string[];
    };
    billingAddress: {
        accordionIconExpanded: Image;
        accordionIconCollapsed: Image;
        label: string;
        searchPlaceholder: string;
        searchIcon: Image;
        noResultsFoundLabel: string;
    };
    clearAllButtonLabel: string;
    applyButtonLabel: string;
}
export interface MyQuotesSectionBottomLabel {
}

export interface MyQuotesPayload {
    skip: number;
    limit: number;
    locations: string[];
    sort: QuotesSort;
    searchValue?: string;
    endDate?: number | string;
    startDate?: number | string;
    status?: string[];
    salesProspectAddress?: LocationAddress[];
}
export interface QuotesSort {
    field: string;
    order: SortOrder;
}

export enum InvoiceStatusLabel {
    all = 'All',
    quoteinProcess = 'In Process',
    quoteAccepted = 'Accepted',
    readyForReview = 'Ready for Review',
    ordered = 'Ordered',
    expired = 'Expired'
}
export enum InvoiceStatusHeader {
    all = 'all',
    quoteinProcess = 'quoteinProcess',
    quoteAccepted = 'quoteAccepted',
    readyForReview = 'readyForReview',
    ordered = 'ordered',
    expired = 'expired'
}
export interface EquipmentQuoteListResponse {
    records: MyQuotesGridListObj[];
    pageInfo: PageInfo;
    inProcessCount: number;
    acceptedCount: number;
    orderedCount: number;
    expiredCount:number;
    readyForReviewCount:number;
}
export interface MyQuotesGridListObj {
    quoteId: string;
    creationDate: string;
    model: string;
    quantity: string;
    billingAddress: Address;
    status: string;
    dealerContact: string;
    dealership: Dealership;
    orderID?: string;
    accordionIconExpanded?: Image;
    accordionIconCollapsed?: Image;
    documentURL?: string | undefined;
}
export interface Dealership{
    dealerName:string;
    addressLine1: string;
    addressLine2?: string;
    city: string;
    zipCode: string;
    state: string;
}
export enum EquipmentQuoteHeader {
    quoteId = 'Quote #',
    creationDate = 'Date Created',
    model = 'Model',
    quantity = 'Quantity',
    billingAddress = 'Billing Address',
    status = 'Status'
}
export interface MyQuotesGridListLabel {
    quoteId: string;
    creationDate: string;
    model: string;
    quantity: string;
    billingAddress: string;
    status: string;
    dealerContact: string;
    dealership: string;
    orderID: string;
    accordionIconExpanded: Image;
    accordionIconCollapsed: Image;
}
export enum StatusPayload {
    quoteinProcess = 'Quote in Process',
    quoteAccepted = 'Quote Accepted',
    ordered = 'Ordered',
    expired = 'Expired',
    readyForReview = 'Ready for Review'
}
export interface BillingAddressPayload {
    locations: string[];
    searchValue?: string;
}
export interface BillingAddressResponse {
    records: LocationAddress[];
}
